<template>
	<div>
		<!-- <h5 v-if="Tocas.length > 0 ">Tocas encontradas </h5>
		<p >{{"Area: " + Tocas[0].Area.Nombre.toUpperCase()}} <br>
			{{"Tipo de Documento: " + Tocas[0].TipoDocumento.Nombre}}
		</p> -->
		<hr>
		<div class="table-responsive ">
			<table v-if="Tocas" class="table table-light table-hover table-bordered table-condensed " id="tablaDeTocas_table">
				<thead class="thead-green">
					<tr>
						<th>Consecutivo</th>
						<th>Recurso</th>
						<th v-if="Tocas[0].TipoAutoridad">Autoridad de Origen</th>
						<th v-if="(areaId != 26 && areaId != 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId == 6)">Relaciones</th>
						<th v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">Juicio</th>
						<th v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">Tramite</th>
						<th v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">Partes</th>
						<th>Acciones</th>
					</tr>
				</thead>
				<tbody >
					<tr v-for="(Toca, indexT) in Tocas" :key="'Toca'+ indexT" >
						<td>{{Toca.Consecutivo}}</td>
						<td v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">{{Toca.NombreJuicio}}</td>
						<td v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">{{Toca.NombreTramite}}</td>
						<td v-if="(areaId != 26 && areaId != 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId == 6)">
								<div id="tabla_responsiva">
									<div class="Rtable Rtable--3cols">
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Ofendido"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
									</div>
							
									<div class="Rtable Rtable--3cols"v-for="(Relacion, indexRe) in Toca.Relaciones" >
										<div style="order:1;" class="Rtable-cell">{{getOfendido(Relacion, Toca.Partes, Toca.TiposPartes)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getInculpado(Relacion, Toca.Partes, Toca.TiposPartes)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getDelito(Relacion, Toca.Partes, Toca.TiposPartes)}}</div>
									</div>
								</div>
								<div id="tabla_tambien_responsiva">
									<div class="Rtable--3cols Rtable Rtable--collapse"">
										<div v-for="(Relacion, indexRe) in Toca.Relaciones" >
											<div class="Rtable-cell Rtable-cell--darker">{{"Ofendido"}}</div>
											<div class="Rtable-cell">{{getOfendido(Relacion, Toca.Partes, Toca.TiposPartes)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
											<div class="Rtable-cell">{{getInculpado(Relacion, Toca.Partes, Toca.TiposPartes)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
											<div class="Rtable-cell">{{getDelito(Relacion, Toca.Partes, Toca.TiposPartes)}}</div>
											<hr>
										</div>
									</div>
								</div>
						</td>
						<td v-else>
							<div>
								<div v-for="(Partes, indexP) in getTiposParte(Toca.Partes, Toca.TiposPartes)">
									<div><b>{{Partes.TipoPersonalidad + ":"}}</b> <br> {{Partes.Nombre}}</div>
								</div>
							</div>
						</td>
						<td>
							<i class="fas fa-plus fa-2x" @click="registrarRelacionExpediente(Toca)" title="Relacionar Expediente"></i>

						</td>
					</tr>
				</tbody>
			</table>
			<!-- Tabla toca seleccionada -->
			<table v-if="datosToca && expedienteToca == undefined" class="table table-light table-hover table-bordered table-condensed " id="tablaDeToca_table">
				<thead class="thead-green">
					<tr>
						<th>Consecutivo</th>
						<th>Recurso</th>
						<th v-if="datosToca[0].TipoAutoridad">Autoridad de Origen</th>
						<th v-if="(areaId != 26 && areaId != 116  && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId == 6)">Relaciones</th>
						<th v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">Juicio</th>
						<th v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">Tramite</th>
						<th v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">Partes</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(Toca, indexDT) in datosToca" :key="'datosToca'+ indexDT" >
						<td>{{Toca.Consecutivo}}</td>
						<td v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">{{Toca.NombreJuicio}}</td>
						<td v-if="(areaId == 26 || areaId == 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId != 6)">{{Toca.NombreTramite}}</td>
						<td v-if="(areaId != 26 && areaId != 116 && areaId != 37) || (areaId == 37 && Tocas[0].Materia.MateriaId == 6)">
								<div id="tabla_responsiva">
									<div class="Rtable Rtable--3cols">
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Ofendido"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
									</div>
							
									<div class="Rtable Rtable--3cols"v-for="(Relacion, indexRe) in Toca.Relaciones" >
										<div style="order:1;" class="Rtable-cell">{{getOfendido(Relacion, Toca.Partes)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getInculpado(Relacion, Toca.Partes)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getDelito(Relacion, Toca.Partes)}}</div>
									</div>
								</div>
								<div id="tabla_tambien_responsiva">
									<div class="Rtable--3cols Rtable Rtable--collapse"">
										<div v-for="(Relacion, indexRe) in Toca.Relaciones" >
											<div class="Rtable-cell Rtable-cell--darker">{{"Ofendido"}}</div>
											<div class="Rtable-cell">{{getOfendido(Relacion, Toca.Partes)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
											<div class="Rtable-cell">{{getInculpado(Relacion, Toca.Partes)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
											<div class="Rtable-cell">{{getDelito(Relacion, Toca.Partes)}}</div>
											<hr>
										</div>
									</div>
								</div>
						</td>
						<td v-else>
							<div>
								<div v-for="(Partes, indexPa) in getTiposParte(Toca.Partes, Toca.TiposPartes)">
									<div><b>{{Partes.TipoPersonalidad + ":"}}</b> <br> {{Partes.Nombre}}</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if="datosToca && expedienteToca == undefined" class="form-group" id="juzgadoExterno_div" @change="esJuzgadoExterno($event)">
          	<h6>Es Juzgado Externo</h6><input type="checkbox" id="juzgadoExterno" v-model="juzgadoExterno"  >
          
    		</div>
			<!--Tabla expediente-->
			<!-- <div v-if="expedienteToca" class="form-group" id="pleno_div" @change="esPleno($event)">
          	<h6>Es De Pleno</h6><input type="checkbox" id="pleno" v-model="pleno">
          
    		</div> -->
			<table v-if="expedienteToca" class="table table-light table-hover table-bordered table-condensed " id="tablaDeExpediente_table">
				<thead class="thead-green">
					<tr>
						<th>Consecutivo</th>
						<th>Juzgado</th>
						<th style="width: 3%">Tipo de Documento</th>
						<th>Partes Registradas</th>
						<th style="width: 3%">Abrir Formulario Para Guardar Orden de Protección</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(Expediente, indexE) in expedienteToca" :key="'Expediente'+indexE">
					<td>{{Expediente.Consecutivo + (Expediente.NumeroRomano ? " - "+ Expediente.NumeroRomano : "") 
												 + (Expediente.NumeroDeDocumentoTexto ? " #" + Expediente.NumeroDeDocumentoTexto : "") }}</td>
					<td>{{Expediente.Area.Nombre}}</td>
					<td>{{Expediente.TipoDocumento.Nombre}}</td>
					<td>
						<div v-if="Expediente.PartesEquitas">
							<div>
								<div v-for="(Partes, indexPar) in getTiposParteEQ(Expediente.PartesEquitas, Expediente.TiposPartes)">
									<div><b>{{Partes.TipoPersonalidad + ":"}}</b><br> {{Partes.Nombre}}</div>
								</div>
							</div>
						</div>
						<div v-if="Expediente.PartesMajat">
								<div id="tabla_responsiva">
									<div class="Rtable Rtable--3cols">
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Ofendido"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
									</div>
							
									<div class="Rtable Rtable--3cols"v-for="(Relacion, indexRe) in Expediente.RelacionesMajat" >
										<div style="order:1;" class="Rtable-cell">{{getOfendido(Relacion, Expediente.PartesMajat)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getInculpado(Relacion, Expediente.PartesMajat)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getDelito(Relacion, Expediente.PartesMajat)}}</div>
									</div>
								</div>
								<div id="tabla_tambien_responsiva">
									<div class="Rtable--3cols Rtable Rtable--collapse"">
										<div v-for="(Relacion, indexRe) in Expediente.RelacionesMajat" >
											<div class="Rtable-cell Rtable-cell--darker">{{"Ofendido"}}</div>
											<div class="Rtable-cell">{{getOfendido(Relacion, Expediente.PartesMajat)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
											<div class="Rtable-cell">{{getInculpado(Relacion, Expediente.PartesMajat)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
											<div class="Rtable-cell">{{getDelito(Relacion, Expediente.PartesMajat)}}</div>
											<hr>
										</div>
									</div>
								</div>
						</div>
						<div v-if="Expediente.PartesSIOP">
							<div id="tabla_responsiva">
									<div class="Rtable Rtable--3cols">
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Ofendido"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
										<div style="order:0;" class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
									</div>
							
									<div class="Rtable Rtable--3cols"v-for="(Relacion, indexRe) in Expediente.RelacionesSIOP" >
										<div style="order:1;" class="Rtable-cell">{{getOfendido(Relacion, Expediente.PartesSIOP)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getInculpado(Relacion, Expediente.PartesSIOP)}}</div>
										<div style="order:1;" class="Rtable-cell">{{getDelito(Relacion, Expediente.PartesSIOP)}}</div>
									</div>
								</div>
								<div id="tabla_tambien_responsiva">
									<div class="Rtable--3cols Rtable Rtable--collapse"">
										<div v-for="(Relacion, indexRe) in Expediente.RelacionesSIOP" >
											<div class="Rtable-cell Rtable-cell--darker">{{"Ofendido"}}</div>
											<div class="Rtable-cell">{{getOfendido(Relacion, Expediente.PartesSIOP)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Inculpado"}}</div>
											<div class="Rtable-cell">{{getInculpado(Relacion, Expediente.PartesSIOP)}}</div>
											<div class="Rtable-cell Rtable-cell--dark">{{"Delito"}}</div>
											<div class="Rtable-cell">{{getDelito(Relacion, Expediente.PartesSIOP)}}</div>
											<hr>
										</div>
									</div>
								</div>
						</div>
					</td>
					<td><i class="fas fa-plus fa-2x" title="Registrar" @click="registrarRelacionExpediente(Expediente)"></i></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	
</template>
<script>
	import Vue from 'vue'

	export default{
		data(){
			return {
				juzgadoExterno: false,
				pleno: false,
			}
		},
		props:{
			Tocas: null,
			areaId: null,
			datosToca: null,
			expedienteToca: null
		},
		mounted() { 
            this.$nextTick(()=> { PaginarTabla('tablaDeTocas_table', 5)});
        },
        created() {

        },
        methods:{
        	getOfendido: function(Relacion, Partes){
        		var OfendidoId = (Relacion.Personalidad != undefined || Relacion.Personalidad != null) 
        					   ? Relacion.Personalidad.SujetoID 
        					   : Relacion.C021Personalidades_Victima.C021PersonalidadId
        		 
        		var Ofendido = (Relacion.Personalidad != undefined || Relacion.Personalidad != null)
        					 ? Partes.filter(item => `${item.SujetoID}`.includes(OfendidoId)) 
        					 : Partes.filter(item => `${item.C021PersonalidadId}`.includes(OfendidoId)) 
        		return ((Ofendido[0].Nombre) ? Ofendido[0].Nombre : Ofendido[0].C027Nombres).toUpperCase();
        	},
        	getInculpado: function(Relacion, Partes){
        		var InculpadoId = (Relacion.Personalidad1 != undefined || Relacion.Personalidad1 != null)
        						? Relacion.Personalidad1.SujetoID
        						: Relacion.C021Personalidades_Imputado.C021PersonalidadId
        		var Inculpado = (Relacion.Personalidad1 != undefined || Relacion.Personalidad1 != null)
        					  ? Partes.filter(item => `${item.SujetoID}`.includes(InculpadoId))
        					  : Partes.filter(item => `${item.C021PersonalidadId}`.includes(InculpadoId))
        		return ((Inculpado[0].Nombre) ? Inculpado[0].Nombre : Inculpado[0].C027Nombres).toUpperCase();
        	},
        	getDelito: function(Relacion, Partes){
        		var Delito = (Relacion.Delito != undefined || Relacion.Delito != null)
        				   ?  Relacion.Delito.Nombre
        				   :  Relacion.C032Descripcion

        		return Delito;
        	},
        	getTiposParte: function(Partes, TiposPartes){
        		var ObjetoParte = [];
        		Partes.forEach((Parte, index) => {
        			let parte = TiposPartes.filter(item => `${item.SujetoID}`.includes(Parte.SujetoID))
        			ObjetoParte.push({ Nombre: Parte.Nombre.toUpperCase(), 
        							   TipoPersonalidad: parte[0].TipoPersonalidad.Nombre,
        							   TipoPersonalidadID: parte[0].TipoPersonalidad.TipoPersonalidadID});

        		});
        		ObjetoParte.sort((a, b) => a.TipoPersonalidadID - b.TipoPersonalidadID);
        		return ObjetoParte;
        	},
        	getTiposParteEQ: function(Partes, TiposPartes){
        		var ObjetoParte = [];
        		Partes.forEach((Parte, index) => {
        			let parte = TiposPartes.filter(item => `${item.si13_ide_pers}`.includes(Parte.si13_ide_pers))
        			ObjetoParte.push({ Nombre: Parte.si13_nom_pers.toUpperCase(),
        							TipoPersonalidad: parte[0].SI53TIPPERS.si53_des_pers.toUpperCase(),
        							TipoPersonalidadID: parte[0].SI53TIPPERS.si53_ide_tper});

        		});
        		ObjetoParte.sort((a, b) => a.TipoPersonalidadID - b.TipoPersonalidadID);
        		return ObjetoParte;
        	},
        	registrarRelacionExpediente:function(Toca){
        		this.$emit("registrarRelacionExpediente", Toca);
        	},
        	guardarRelacionTocaExpediente:function(datosToca, expedienteToca){
        		this.$emit("guardarRelacionTocaExpediente", datosToca[0], expedienteToca)
        	},
        	esJuzgadoExterno:function(externo){
        		this.$emit("limpiarFiltrosJuzgadoExterno", externo.target.checked);
        	},
        	esPleno:function(pleno){
        		this.$emit("esPleno", pleno.target.checked);
        	},

        }
	}


</script>
<style scoped>
.relacionesDelito td{
	width: 33%
}
.relacionesDelito {
	background-color: #cdd5db;
	width: 33%;
	display: flex;
}

.Rtable{
	position: relative; 
	top: @bw; 
	left: @bw;
	display: flex;
  	flex-wrap: wrap;
  	margin: 0 0 3em 0;
  	padding: 0;
}
.Rtable-cell {
  margin: -@bw 0 0 -@bw;  
  width: 100%;  
  padding: 0.8em 1.2em;
  overflow: hidden;
}
.Rtable--3cols > .Rtable-cell  { 
	width: 33.33%; 
}
.Rtable-cell--dark {
  	background-color: #cdd5db;
  	border-color: darken(@tableColour,10%);
}
.Rtable-cell--darker {
  	background-color: #767983;
  	border-color: darken(@tableColour,20%);
}.

hr{
	border: 0;
  	clear:both;
  	display:block;
  	width: 96%;               
  	background-color:#FFFF00;
  	height: 1px;
}
@media all and (max-width: 800px){
	.Rtable--collapse{
		display: block;
		> .Rtable-cell{ width: 100% !important; }

	}
	#tabla_responsiva{
		display: none;
	}
}
@media all and (min-width: 801px){
	.Rtable--collapse{
		display: block;
		> .Rtable-cell{ width: 100% !important; }

	}
	#tabla_tambien_responsiva{
		display: none;
	}
}
.thead-green{
    background-color: var(--verde-pj-100);
    }
	
</style>


// WEBPACK FOOTER //
// src/components/REGOP/Comun/TablaDeResultados.vue